import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { DropdownContent, Typography } from 'shared/ui'
import { TimePicker } from 'shared/ui/DatePicker'
import { type SearchDropdownTimeRangeStore } from 'widgets/SearchDropdown/store/searchDropdownTimeRangeStore'
import styles from './styles.module.scss'

type ITimeRangeDropdownContentProps = {
  onCloseMenu: () => void
  store: SearchDropdownTimeRangeStore
  parentsDropdownId?: string[]
}

export const TimeRangeDropdownContent = observer(
  ({ store, parentsDropdownId }: ITimeRangeDropdownContentProps) => {
    const {
      fromTime,
      toTime,
      setBusinessHours,
      filteredRemainingTime,
      filteredPassedTime,
      selectStartTime,
      selectEndTime,
    } = store

    useEffect(() => {
      setBusinessHours()
    }, [])

    return (
      <DropdownContent className={styles.container}>
        <div className={styles.timeSelector}>
          <Typography
            variant='text-input-field-r'
            ariaLabel='FromTimeDropdownLabel'
            color='var(--content-primary-primary)'
          >
            From
          </Typography>
          <TimePicker
            onChange={selectStartTime}
            selected={fromTime}
            parentsDropdownId={parentsDropdownId}
            filteredRemainingTime={filteredRemainingTime}
            minuteStep={60}
            textFieldPlaceholderProps={{
              placeholder: 'Select time',
              className: styles.inputTimePicker,
              leftActions: [],
            }}
            topListTextFieldProps={{
              leftActions: [],
              readOnly: true,
            }}
          />
        </div>
        <div className={styles.timeSelector}>
          <Typography
            variant='text-input-field-r'
            ariaLabel='ToTimeDropdownLabel'
            color='var(--content-primary-primary)'
          >
            To
          </Typography>
          <TimePicker
            onChange={selectEndTime}
            selected={toTime}
            parentsDropdownId={parentsDropdownId}
            filteredPassedTime={filteredPassedTime}
            minuteStep={60}
            textFieldPlaceholderProps={{
              placeholder: 'Select time',
              className: styles.inputTimePicker,
              leftActions: [],
            }}
            topListTextFieldProps={{
              leftActions: [],
              readOnly: true,
            }}
          />
        </div>
      </DropdownContent>
    )
  }
)
